import React from 'react'
import $ from 'jquery'

import smoothScroll from 'jquery-smooth-scroll'

import projectData from '../project-data'
import Project from './project'

export default class Projects extends React.Component {
	constructor(props) {
		super(props)
		
		this.handleNavClick = this.handleNavClick.bind(this)
		this.renderProjects = this.renderProjects.bind(this)
		this.renderNav = this.renderNav.bind(this)
	}

	componentDidMount() {
		$('.project__nav a').smoothScroll({ offset: -100,});
	}
	

	// ** CLASS METHODS ** //

	handleNavClick(e) {
		e.preventDefault()
	}	

	renderProjects(project) {
		const { title, description, image, role, link, alink, backgroundPosition } = project

		return(
			<Project 
				title={ title }
				description={ description }
				role={ role }
				link={ link }
				image={ image }
				key={ title }
				alink={ alink } 
				backgroundPosition={ backgroundPosition }
			/>
		)
	}

	renderNav(project) {
		const { title, alink } = project

		return(
			<li className="project__list__item" title={title} data-alink={alink} key={title}>
				<a className="project__nav__link" onClick={this.handleNavClick} href={`#${alink}`} >{title}</a>
			</li>
		)
	}


	// ** RENDER ** //

	render() {
		return(
			<div className="container__projects__outer">
	      <div className="container__projects">
					<div className="project__shapes">
						<div className="one shape"></div>
						<div className="two shape"></div>
						<div className="three shape"></div>
						<div className="four shape"></div>
						<div className="five shape"></div>
						<div className="six shape"></div>
						<div className="seven shape"></div>
					</div>

					<div className="container__projects__list">
						{ projectData.map(this.renderProjects) }
					</div>

					<div className="project__nav natural">
						<ul>
							{ projectData.map(this.renderNav) }
						</ul>
					</div>				

	      </div>
			</div>
		)	
	}
}


/** WEBPACK FOOTER **
 ** ./js/components/projects.js
 **/